import {
  Box,
  PopoverBody,
  PopoverContent,
  popoverVariants,
  BoxProps,
} from "@hightouch/htui";
import { ReactNode } from "react";

const outerSpacing = 1.5;

/**
 * Shared styles for nav popover menu items.
 */
export const NAV_POPOVER_MENU_ITEM_STYLES = {
  borderRadius: "xl",
  p: 2,
  mx: outerSpacing,
  fontWeight: "medium",
  transitionProperty: "background-color, color",
  transitionDuration: "fast",
  transitionTimingFunction: "easeOutQuad",
  _focusVisible: {
    bg: "base.background",
    outline: "none",
    boxShadow: "outline",
    zIndex: 1,
  },
};

/**
 * Replaces PopoverContent and PopoverBody with shared styles.
 */
export const NavPopoverContentAndBody = ({
  children,
  width = "240px",
}: {
  children: ReactNode;
  width?: BoxProps["width"];
}) => {
  return (
    <PopoverContent
      border="none"
      borderRadius="xl"
      overflow="hidden"
      boxShadow="lg"
      py={outerSpacing}
      motionProps={popoverVariants}
      width={width}
    >
      <PopoverBody p={0} display="flex" flexDir="column">
        {children}
      </PopoverBody>
    </PopoverContent>
  );
};

export const PopoverHeader = ({ title }: { title: string }) => (
  <Box
    as="span"
    color="text.tertiary"
    fontSize="sm"
    fontWeight="normal"
    height={8}
    p={2}
    mx={1.5}
  >
    {title}
  </Box>
);
